import { useEffect, useRef } from "react";

const EmailPreviewFrame = ({ htmlContent, cssContent, previewMode }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    bindHtmlContent();
  }, [htmlContent, cssContent, previewMode]);

  const bindHtmlContent = () => {
    if (!iframeRef.current) return;
    
    const doc = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;

    // Add a script to handle React Router related errors in the iframe
    const routerHandlingScript = `
      <script>
        // Mock React Router hooks and context to prevent errors
        window.ReactRouterDOM = {
          useLocation: function() { return { pathname: '/preview' }; },
          useNavigate: function() { return function() {}; },
          useParams: function() { return {}; },
          useRouteMatch: function() { return {}; }
        };
        
        // Capture and suppress any remaining Router errors
        window.addEventListener('error', function(event) {
          if (event.message && (
              event.message.includes('useLocation') || 
              event.message.includes('useNavigate') || 
              event.message.includes('useParams') ||
              event.message.includes('Router') ||
              event.message.includes('react-router')
            )) {
            event.preventDefault();
            console.warn('React Router error suppressed in preview iframe:', event.message);
            return true;
          }
        });
      </script>
    `;

    const fullHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8" />
          <style>${cssContent || ""}</style>
          ${routerHandlingScript}
        </head>
        <body style="margin:0;padding:0;">
          ${htmlContent || ""}
        </body>
      </html>
    `;

    doc.open();
    doc.write(fullHtml);
    doc.close();
  }
  
  const isMobile = previewMode === "mobile";
  return (
    <iframe
      ref={iframeRef}
      title="Email Preview"
      style={{
        width: isMobile ? "375px" : "100%",
        height: "80vh",
        borderRadius: "8px",
        border: "1px solid #ccc",
        margin: isMobile ? "0 auto" : "0",
        display: "block",
        boxShadow: isMobile ? "0 0 10px rgba(0, 0, 0, 0.1)" : "none"
      }}
    />
  );
};

export default EmailPreviewFrame;